import { graphql } from "@/gql";

export const createAndAddOrganisationMemberMutation = graphql(`
  mutation CreateAndAddOrganisationMember(
    $organisation_id: ID!
    $name: String!
    $email: String!
  ) {
    createAndAddOrganisationMember(
      organisation_id: $organisation_id
      name: $name
      email: $email
    ) {
      id
    }
  }
`);
